import { useMatch } from 'react-router-dom';

export function useEventId() {
    const eventMatch = useMatch('/test-event/:eventId/*');
    const irregMatch = useMatch('/irregularities/:step/:eventId/:roomId?');
    return eventMatch?.params?.eventId ?? irregMatch?.params?.eventId ?? null;
}
